import { combineReducers } from 'redux';
import lang from '../language/lang';

export default combineReducers({ lang });
